export default {"src":"/_next/static/media/hfh.6b86e861.svg","height":127,"width":411,"blurWidth":0,"blurHeight":0};